import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const DropdownNav = ({ dropdownRoutes, dropdownClose }) => {
  const navigate = useNavigate();
  const _navigate = (_route) => {
    dropdownClose();
    navigate(_route.route);
  };
  return (
    <Box
      sx={{
        mt: 1,
        minWidth: 200,
        p: 0.75,
        borderRadius: "12px",
        backgroundColor: "background.paper",
        border: 1,
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 16px 40px rgba(0, 0, 0, 0.5)",
      }}
    >
      {dropdownRoutes.map((route) => (
        <Button
          key={route.index}
          target={route.external ? "_blank" : undefined}
          rel={route.external ? "noopener noreferrer" : undefined}
          href={route.external ? route.route : undefined}
          onClick={() => {
            route.external ? dropdownClose() : _navigate(route);
          }}
          sx={{
            justifyContent: "flex-start",
            color: "text.primary",
            fontWeight: 500,
            borderRadius: "8px",
            "&:hover": { backgroundColor: "background.light", color: "text.primary" },
          }}
        >
          {route.label}
        </Button>
      ))}
    </Box>
  );
};
